import { Button } from '@/core/components/ui/button'
import { Outlet, createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'
import { PiArrowLineLeft } from 'react-icons/pi'
import Header from '@/core/components/Header'
import SideBar from '@/core/components/SideBar'
import { ErrorComponent } from '@/core/components/ErrorComponent'
import LoginDialog from '@/core/components/auth/LoginDialog'

export const Route = createFileRoute('/_layout')({
  component: DashboardLayout,
  errorComponent: ErrorComponent,
})

function DashboardLayout() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true)
  return (
    <div className='scrollbar grid min-h-screen  grid-cols-1 md:grid-cols-[auto,1fr]'>
      <aside
        className={` relative hidden min-h-screen bg-primary transition-all duration-200  md:block ${isSidebarOpen ? 'w-[250px]' : 'w-[76px]'}`}
      >
        <Button
          className='group absolute right-[-20px] top-[50px] z-50 rounded-full bg-secondary'
          variant='ghost'
          size='icon'
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        >
          <PiArrowLineLeft
            size={20}
            className={` ${isSidebarOpen ? 'rotate-0' : 'rotate-180'} text-white group-hover:text-primary`}
          />
        </Button>
        <SideBar isSidebarOpen={isSidebarOpen} />
      </aside>
      <div className='overflow-x-hidden'>
        <Header />
        <main className='scrollbar mr-auto w-full max-w-[1440px] overflow-x-hidden p-4  lg:p-7'>
          <Outlet />
        </main>
      </div>
      <LoginDialog />
    </div>
  )
}
